import { TimeSheetDto } from './TimeSheetDto';

export class TimeSheetSaveDto {
  public TimeSheet: TimeSheetDto;
  public SelectedRecordIDs: string[];
  public UnselectedRecordIDs: string[];
}
